module.exports = __webpack_public_path__ + "static/media/word_emo.ee0ca1f9.jpg";